import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import { getTargetGroupAttributes } from "../../../actions/org/OrgTargetGroupActions";
import {
  getPincodeRankingByTg,
  selectTgAttrForRanking,
  unSelectTgAttrForRanking,
} from "../../../actions/regions/RegionActions";

// Utils
import { getMergedCityId } from "../CityInfoTempFixUtil";

// Components
import Spinner from "../../../components/spinner/Spinner";
import CheckBox from "../../../components/check-box/CheckBox";
import { ButtonWithLoader } from "../../../mavin/components/button/Button";

// function
function constructTgAttrData(tgAttrList) {
  // if no data present
  if (!tgAttrList || tgAttrList.length === 0) {
    return [];
  }

  // Constructed Data
  const constructedData = {};
  tgAttrList.map((attr) => {
    const { label, children = [] } = attr;
    const childrenLabels = children.map((child) => child.label);

    // adding to data
    constructedData[label] = childrenLabels;
  });

  return constructedData;
}

/**
 *  Section
 */
export default function TgAttrListingSection({ cityId }) {
  const dispatch = useDispatch();

  // Tg Attr
  const tgAttrLoading = useSelector(
    (state) => state.orgTargetGroup.isGetTgAttrLoading
  );
  const tgAttrList = useSelector((state) => state.orgTargetGroup.dataList);

  // pincode ranking loading
  const pincodeRankingLoading = useSelector(
    (state) => state.region.pincodeRankingLoading
  );

  // Selected TG Attr for Ranking
  const selectedTgAttrForRanking = useSelector(
    (state) => state.region.selectedTgAttrForRanking
  );
  const allSelectedAttrs = Object.values(selectedTgAttrForRanking).flat();

  // constructed data
  const constructedTgAttrData = constructTgAttrData(tgAttrList);

  useEffect(() => {
    if (!tgAttrList || tgAttrList.length === 0) {
      dispatch(getTargetGroupAttributes(true));
    }
  }, [dispatch, JSON.stringify(tgAttrList)]);

  // functions
  function handleCheckBoxChange(isChecked, attrGroup, attrName) {
    const dispatchAction = isChecked
      ? unSelectTgAttrForRanking(attrGroup, attrName)
      : selectTgAttrForRanking(attrGroup, attrName);
    dispatch(dispatchAction);
  }

  function handleGetRanking() {
    // for delhi and mumbai we are hardcoding the their Ids
    const mergedCityId = getMergedCityId(cityId);

    // dispatch
    dispatch(getPincodeRankingByTg(mergedCityId, selectedTgAttrForRanking));
  }

  //  Loading
  if (tgAttrLoading) {
    return (
      <div className="d-flex justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="p-3">
      {Object.keys(constructedTgAttrData).map((attrGroup) => {
        const childrenLabels = constructedTgAttrData[attrGroup];
        return (
          <div key={attrGroup} className="mb-3 border-bottom pb-2">
            <h5>{attrGroup}</h5>

            <div className="row">
              {childrenLabels?.map((eachAttr) => {
                const isChecked = allSelectedAttrs.includes(eachAttr);
                return (
                  <div key={eachAttr} className="col-4">
                    <CheckBox
                      checkBoxKey={eachAttr}
                      boxStyle="px-0"
                      inputBoxStyle="m-0 mr-1"
                      checked={isChecked}
                      onChange={() =>
                        handleCheckBoxChange(isChecked, attrGroup, eachAttr)
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {/* footer */}
      <div className="d-flex justify-content-end mt-3">
        <ButtonWithLoader
          displayContent="Get Area Ranking"
          onClickFunction={handleGetRanking}
          isDisabled={pincodeRankingLoading || allSelectedAttrs.length === 0}
          loader={pincodeRankingLoading}
        />
      </div>
    </div>
  );
}
